import * as React from "react";
import {
  Card as SharedCard,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
} from "@dobbix/ui";
import { cn } from "@/lib/utils";

const Card = React.forwardRef<HTMLDivElement, React.ComponentProps<typeof SharedCard>>(
  ({ className, ...props }, ref) => (
    <SharedCard
      ref={ref}
      className={cn("paper-card rounded-xl p-4 sm:p-6", className)}
      {...props}
    />
  ),
);
Card.displayName = "Card";

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
